/**
 * tracking-providers.js
 */

import React from 'react';
import { TrackProvider } from './track-context';
import { LiveTrackingProvider } from './live-tracking/live-tracking-context';
import { MapProvider } from './map/map-context';
import { TrackingDrawerProvider } from './input-drawers/drawer-context';
import { TrackingFormProvider } from './live-tracking/tracking-form-context';


const PROVIDER_LIST = [{
  id: 'track',
  provider: TrackProvider
}, {
  id: 'map',
  provider: MapProvider
}, {
  id: 'live',
  provider: LiveTrackingProvider
}, {
  id: 'drawer',
  provider: TrackingDrawerProvider
}, {
  id: 'form',
  provider: TrackingFormProvider
}];


export const TrackingProviders = (props) => {
  const { ids } = props;
  const providers = PROVIDER_LIST.filter(p => ids.includes(p.id));
  

  const renderProviders = (providers) => {
    if (providers && providers.length > 0) {
      const Provider = providers[0].provider;
      return (
        <Provider>{renderProviders(providers.slice(1))}</Provider>
      )
    } else {
      return props.children;
    }
  }

  return renderProviders(providers);
}